import { render, staticRenderFns } from "./StaffingPositionActions.vue?vue&type=template&id=b7847326&"
import script from "./StaffingPositionActions.vue?vue&type=script&lang=ts&setup=true&"
export * from "./StaffingPositionActions.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports